import useSWR from "swr";
import { API_BASE_URL } from "@/lib/env";
import type { APISubscription } from "@/api/client";

export function useSubscriptions(enabled = true) {
  const { data, error, isLoading, mutate } = useSWR<APISubscription[]>(
    enabled ? `${API_BASE_URL}/me/subscriptions` : null,
  );

  return {
    subscriptions: data ?? [],
    isLoading: enabled && isLoading,
    isError: !!error,
    refreshSubscriptions: mutate,
  };
}
